import type { UpdateUserDDB } from '../interfaces/user.interface';

export const userUpdateInitialState: UpdateUserDDB = {
  interests: [],
  bio: '',
  companyName: '',
  country: '',
  zipPostalCode: '',
  email: '',
  firstName: '',
  lastName: '',
  jobTitle: '',
  phoneNumber: '',
  username: '',
  password: '',
  passwordConfirm: '',
  role: 'reader',
};
